import React, { Component } from "react";
import * as Moment from "moment";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { setPageTitle, downloadReport } from "signoxe/actions";
import DeviceSummary from "signoxe/components/DeviceSummary";
import {ReportSummary, PingReportView} from "signoxe/components";
import ReportFilter from "signoxe/components/ReportFilter";
import "./styles.scss";
import { Popup } from "signoxe/components/widgets";
import {
  getDeviceGroups,
  getDevices,
  getFeatureStatus,
  getProfile,
} from "signoxe/selectors";
import { getCampaigns } from "signoxe/selectors/campaigns";
import { DeviceSchedulePage } from "..";
import {
  downloadActiveHoursReports,
  downloadReports,
  mailReports,
  mailActiveHoursReports,
} from "signoxe/actions/remote";
import { device } from "signoxe/api/schema";

class ReportsPage extends Component {
  constructor(props) {
    const profile = props.profile
    const features = profile && profile.features;
    const pingWindowEnabled = features && profile.features.ping_window;
    const reportWindowsEnabled = features && profile.features.device_reporting;
    const allowToggle = pingWindowEnabled && reportWindowsEnabled
    const showPingOnly = pingWindowEnabled && !reportWindowsEnabled

    super(props);
    this.state = {
      isVisible: false,
      reportTime: "activeHours",
      reportType: "summary",
      reportFormat: "csv",
      canShowCustomDates: false,
      duration: null,
      startTime: Moment.utc().subtract(1, "days").startOf("day").valueOf(),
      endTime: Moment.utc().subtract(1, "days").endOf("day").valueOf(),
      deviceIds: [],
      device_ids: [],
      campaignIds: [],
      checked: [],
      type: null,
      isAllSelected: false,
      reportTimeIterval: Moment.utc()
        .subtract(1, "days")
        .startOf("day")
        .valueOf(),
      downloading: false,
      showMailReportMessage: false,
      showMailReportButton: false,
      deviceSearchTerm: "",
      campaignSearchItem: "",
      toggleSwitch: showPingOnly,
    };
    this.showReportFilter = this.showReportFilter.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleStartTimeChange = this.handleStartTimeChange.bind(this);
    this.handleIntervalChange = this.handleIntervalChange.bind(this);
    this.handleReportDownload = this.handleReportDownload.bind(this);
    this.handleOptionSelect = this.handleOptionSelect.bind(this);
    this.handleSelectAll = this.handleSelectAll.bind(this);
    this.handleCustomIntervalChange =
      this.handleCustomIntervalChange.bind(this);
    this.handleMailReport = this.handleMailReport.bind(this);
  }

  static propTypes = {
    // Data

    // Functions
    setPageTitle: PropTypes.func.isRequired,
    profile: PropTypes.array.isRequired,
  };
   
  componentDidMount() {
    const { profile } = this.props;
    const features = profile && profile.features;
    const pingWindowEnabled = features && profile.features.ping_window;
    const reportWindowsEnabled = features && profile.features.device_reporting;
    if (!reportWindowsEnabled && !pingWindowEnabled) {
      this.props.history.push("/assets");
    }
    this.props.setPageTitle("Report Summary");

  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }
  showReportFilter(type, data) {
    const { deviceIds, campaignIds } = this.state;

    if (type === "device" && deviceIds && deviceIds.length === 0) {
      alert("Please select atleast one device to proceed");
      return false;
    }

    if (type === "campaign" && campaignIds && campaignIds.length === 0) {
      alert("Please select atleast one campaign to proceed");
      return false;
    }
    this.setState({ isVisible: true, type, data });
  }

  handleClose() {
    this.setState({ isVisible: false });
  }
  handleStartTimeChange = (newValue) => {
    this.setState({
      startTime: newValue,
      endTime: Moment(newValue).add(1, "days").toDate(),
    });
  };

  handleEndTimeChange = (newValue) => {
    this.setState({ endTime: newValue });
  };

  handleSelectAll = (typeOfReport) => {
    const { devices, campaigns } = this.props;
    const { isAllSelected } = this.state;

    var allSelectStatus = !isAllSelected;
    this.setState({ isAllSelected: allSelectStatus, type: typeOfReport });
    var checkedCopy = [];
    if (typeOfReport === "device") {
      let deviceIdArr = [];
      let deviceIdsArr = [];
      devices.forEach((device, index) => {
        checkedCopy.push(allSelectStatus);
        deviceIdArr.push(device.id);
        let obj = {
          device_id: device.device_id,
        };
        deviceIdsArr.push(obj);
      });
      this.setState({ checked: checkedCopy });

      if (allSelectStatus) {
        this.setState({ deviceIds: deviceIdArr, device_ids: deviceIdsArr });
      } else {
        this.setState({ deviceIds: [], device_ids: [] });
      }
    }

    if (typeOfReport === "campaign") {
      let campaignIdArr = [];
      campaigns.forEach((campaign, index) => {
        checkedCopy.push(allSelectStatus);
        campaignIdArr.push(campaign.id);
      });
      this.setState({ checked: checkedCopy });
      if (allSelectStatus) {
        this.setState({ campaignIds: campaignIdArr });
      } else {
        this.setState({ campaignIds: [] });
      }
    }
  };

  handleCustomIntervalChange = (e, endDate) => {
    let selectedInterval = e.target.value;

    if (selectedInterval !== "custom") {
      this.setState({
        startTime: parseInt(selectedInterval),
        endTime: endDate,
        canShowCustomDates: false,
      });
    } else {
      this.setState({ canShowCustomDates: true, startTime: null });
    }
    this.setState({ showMailReportButton: true });
  };

  handleIntervalChange = (e, endDate) => {
    this.setState({ showMailReportButton: false });

    let selectedInterval = e.target.value;

    if (selectedInterval !== "custom") {
      this.setState({
        startTime: parseInt(selectedInterval),
        endTime: endDate,
        canShowCustomDates: false,
      });
    } else {
      this.setState({ canShowCustomDates: true, startTime: null });
    }
  };

  download_state = (fetching) => {
    console.log(fetching);
    console.log(this.state.downloading);
    this.setState({ downloading: fetching });
    this.setState({ isVisible: false });
  };

  handleMailReport() {
    const {
      startTime,
      endTime,
      reportTime,
      reportType,
      reportFormat,
      deviceIds,
      device_ids,
      type,
      campaignIds,
    } = this.state;

    let formatedStartTime = Moment(startTime).isValid()
      ? Moment(startTime).valueOf()
      : startTime;
    let formatedEndTime = Moment(endTime).isValid()
      ? Moment(endTime).valueOf()
      : endTime;

    if (type === "device" && deviceIds && deviceIds.length === 0) {
      alert("Please select atleast one device to proceed");
      return false;
    }
    if (type === "campaign" && campaignIds && campaignIds.length === 0) {
      alert("Please select atleast one campaign to proceed");
      return false;
    }

    let reportData = {
      start_time: formatedStartTime,
      end_time: formatedEndTime,
      format: reportType,
    };

    if (type === "device") {
      reportData["devices"] = deviceIds;
    }

    if (type === "campaign") {
      reportData["campaigns"] = campaignIds;
    }

    if (reportTime === "activeHours") {
      this.setState({ downloading: true });
      let objData = {
        device_ids: deviceIds,
      };
      this.props.mailActiveHoursReports(objData, this.download_state);
    } else {
      this.setState({ downloading: true });
      this.props.mailReports(reportData, type, this.download_state);
    }

    this.setState({ deviceIds: [], device_ids: [] });
    this.setState({ isVisible: false });
    this.setState({ showMailReportMessage: !this.state.showMailReportMessage });
  }

  handleReportDownload() {
    const {
      startTime,
      endTime,
      reportTime,
      reportType,
      reportFormat,
      deviceIds,
      device_ids,
      type,
      campaignIds,
    } = this.state;

    let formatedStartTime = Moment(startTime).isValid()
      ? Moment(startTime).valueOf()
      : startTime;
    let formatedEndTime = Moment(endTime).isValid()
      ? Moment(endTime).valueOf()
      : endTime;

    if (type === "device" && deviceIds && deviceIds.length === 0) {
      alert("Please select atleast one device to proceed");
      return false;
    }
    if (type === "campaign" && campaignIds && campaignIds.length === 0) {
      alert("Please select atleast one campaign to proceed");
      return false;
    }

    let reportData = {
      start_time: formatedStartTime,
      end_time: formatedEndTime,
      format: reportType,
    };

    if (type === "device") {
      reportData["devices"] = deviceIds;
    }

    if (type === "campaign") {
      reportData["campaigns"] = campaignIds;
    }

    if (reportTime === "activeHours") {
      this.setState({ downloading: true });
      let objData = {
        device_ids: deviceIds,
      };
      this.props.downloadActiveHoursReports(objData, this.download_state);
    } else {
      this.setState({ downloading: true });
      this.props.downloadReports(reportData, type, this.download_state);
    }

    this.setState({ deviceIds: [], device_ids: [] });
  }

  handleOptionSelect(selectedId, typeOfReport, selectedDeviceId) {
    const { deviceIds, campaignIds } = this.state;

    this.setState({ type: typeOfReport });
    if (typeOfReport === "device") {
      const obj = { device_id: selectedDeviceId };

      this.setState({
        device_ids: [...this.state.device_ids, obj],
      });

      let isDeviceSelected =
        deviceIds.findIndex((device) => device === selectedId) !== -1;

      if (isDeviceSelected) {
        this.setState({
          deviceIds: deviceIds.filter((device) => device !== selectedId),
        });
      } else {
        this.setState({
          deviceIds: [...deviceIds, selectedId],
        });
      }
    }

    if (typeOfReport === "campaign") {
      let isCampaignSelected =
        campaignIds.findIndex((campaign) => campaign === selectedId) !== -1;

      if (isCampaignSelected) {
        this.setState({
          campaignIds: campaignIds.filter(
            (campaign) => campaign !== selectedId
          ),
        });
      } else {
        this.setState({
          campaignIds: [...campaignIds, selectedId],
        });
      }
    }
  }

  handleShowMailReportButton = () => {
    this.setState({ showMailReportButton: true });
  };

  handleMailReportMessage = () => {
    this.setState({ isVisible: false });
    this.setState({ showMailReportMessage: !this.state.showMailReportMessage });
  };
  onCancel = () => {
    this.setState({ showMailReportMessage: !this.state.showMailReportMessage });
  };

  handleDeviceReportSearch = (e) => {
    this.setState({ deviceSearchTerm: e.target.value });
  };

  handleCampaignReportSearch = (e) => {
    this.setState({ campaignSearchItem: e.target.value });
  };

  onToggleEdit = () => {
    this.setState({ toggleSwitch: !this.state.toggleSwitch });
  };
  render() {
    const {
      isVisible,
      reportTime,
      reportType,
      startTime,
      canShowCustomDates,
      endTime,
      reportFormat,
      type,
      campaignIds,
      deviceIds,
      isAllSelected,
      checked,
      showMailReportMessage,
      showMailReportButton,
      deviceSearchTerm,
      campaignSearchItem,
      toggleSwitch,
    } = this.state;
    const { groups, campaigns, devices } = this.props;

    const { profile } = this.props;
    const profile = this.props.profile
    const allowed_pages = profile && this.props.profile.allowed_pages
    const isNotAllowed = profile && allowed_pages && this.props.profile.allowed_pages.report_page

    const features = profile && profile.features;
    const pingWindowEnabled = features && profile.features.ping_window;
    const reportWindowsEnabled = features && profile.features.device_reporting;
    const allowToggle = pingWindowEnabled && reportWindowsEnabled
    const showPingOnly = pingWindowEnabled && !reportWindowsEnabled

    return (
     <>
    { !isNotAllowed ? <>
      
      {allowToggle ? (
          <div
            className="flex flex-jc-sb flex-ai-c mt-1 ping_view_btn"
          >
            <div></div>
            <button
              className= {`button ${toggleSwitch ? " btn-bg" : ""} `}
              onClick={this.onToggleEdit}
            >
              <i
                className={
                  toggleSwitch
                    ? "fas fa-toggle-on mr-1"
                    : "fas fa-toggle-off mr-1"
                }
              ></i>
             {toggleSwitch ? "View Reports" : "View Ping Reports"}
            </button>
          </div>
        ) : null}

         <div>
           {!toggleSwitch ? 
           <>
         { reportWindowsEnabled && <div className={`ReportsPage ${isVisible && "fade"}`}>
            {showMailReportMessage ? (
              <Popup className="text-center" title="Mail Report Request" modal>
                <p className="pad-1">
                Your request has been taken. You should shortly receive a download link 
                for requested report on your registered email id.
                </p>
                <div className="pad-1 text-center pb flex flex-jc-sb">
                  <div></div>
                  <button className="button" onClick={this.onCancel}>
                    Close
                  </button>
                </div>
              </Popup>
            ) : null}

            {isVisible && (
              <Popup>
                <ReportFilter
                  downloading={this.state.downloading}
                  title="product X"
                  className="popup"
                  onClose={this.handleClose}
                  reportTime={reportTime}
                  reportType={reportType}
                  reportFormat={reportFormat}
                  onInputChange={this.handleInputChange}
                  isCustomDate={canShowCustomDates}
                  onStartTimeChange={this.handleStartTimeChange}
                  onEndTimeChange={this.handleEndTimeChange}
                  startTime={startTime}
                  endTime={endTime}
                  onMailReport={this.handleMailReport}
                  onIntervalChange={this.handleIntervalChange}
                  onCustomIntervalChange={this.handleCustomIntervalChange}
                  onDownload={this.handleReportDownload}
                  handleMailReportMessage={this.handleMailReportMessage}
                  handleShowMailReportButton={this.handleShowMailReportButton}
                  showMailReportButton={showMailReportButton}
                />
              </Popup>
            )}

            <div className="ReportsPage__column">
              {/* <DeviceSummary isOn={true} /> */}
              <ReportSummary
                title="Device Report"
                onProceed={this.showReportFilter}
                data={devices}
                searchTerm={deviceSearchTerm}
                handleSearch={this.handleDeviceReportSearch}
                onOptionSelect={this.handleOptionSelect}
                type="device"
                onSelectAll={this.handleSelectAll}
                isAllSelected={isAllSelected}
                checked={checked}
                deviceIds={deviceIds}
                campaignIds={campaignIds}
                selectedType={type}
              />
            </div>
            <div className="ReportsPage__column">
              {/* <DeviceSummary isOn={false} /> */}
              <ReportSummary
                title="Campaign Report"
                onProceed={this.showReportFilter}
                data={campaigns}
                searchTerm={campaignSearchItem}
                handleSearch={this.handleCampaignReportSearch}
                onOptionSelect={this.handleOptionSelect}
                type="campaign"
                onSelectAll={this.handleSelectAll}
                isAllSelected={isAllSelected}
                checked={checked}
                deviceIds={deviceIds}
                campaignIds={campaignIds}
                selectedType={type}
              />
            </div>
            <div className="big_wrap">
              <div className="canvas-wrap">
                <canvas id="canvas" width="300" height="300"></canvas>
                <span id="procent"></span>
              </div>
            </div>
          </div>}
           </>:
         <>
        { pingWindowEnabled && <PingReportView/>}
         </>
         }
         </div>
      </>: 
          <div className="flex flex-jc-c ai-i-c" style={{ marginTop: '40%' }}> You don't have permission to view this page. </div> }        
      </>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    downloadReport: (deviceID, download_state) =>
      dispatch(downloadReport(deviceID, download_state)),
    downloadReports: (data, reportType, download_state) =>
      dispatch(downloadReports(data, reportType, download_state)),
    downloadActiveHoursReports: (data, download_state) =>
      dispatch(downloadActiveHoursReports(data, download_state)),
    mailReports: (data, reportType, download_state) =>
      dispatch(mailReports(data, reportType, download_state)),
    mailActiveHoursReports: (data, download_state) =>
      dispatch(mailActiveHoursReports(data, download_state)),
    setPageTitle,
  };
};

export default connect(
  (state) => ({
    isFetching: state.assets.isFetching,
    groups: getDeviceGroups(state),
    campaigns: getCampaigns(state),
    devices: getDevices(state),
    isReportEnabled: getFeatureStatus(state, "device_reporting"),
    profile: getProfile(state),
  }),
  mapDispatchToProps
)(ReportsPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/ReportsPage/index.js